import React from 'react';
import { Box, Button, CircularProgress, Tooltip } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import VideocamIcon from '@material-ui/icons/Videocam';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import { useStyles } from './Themable.hooks';

import TranslationHelper from '../../helpers/TranslationHelper';
import DownloadIcon from '@material-ui/icons/GetApp';

interface ICopyButton {
    title: string;
    callback: () => void;
}
interface IOwnProps {
    copyLink?: ICopyButton;
    copyVideoLink?: ICopyButton;
    downloadProps?: {
        handleDownloadFrame: () => void;
        handleDownloadMovie: () => void;
        downloadInProgress: boolean;
    };
}

const PlayerDropdownOptions = ({
    copyLink,
    copyVideoLink,
    downloadProps,
}: IOwnProps) => {
    const classes = useStyles();
    const { handleDownloadFrame, handleDownloadMovie, downloadInProgress } =
        downloadProps ?? {};
    return (
        <div className={classes.options}>
            {copyLink && (
                <Tooltip title={copyLink.title} placement="top">
                    <Button
                        aria-label="copy"
                        className={classes.copyButton}
                        size="small"
                        startIcon={<LinkIcon />}
                        onClick={copyLink.callback}
                    >
                        {TranslationHelper.translate('Copy link')}
                    </Button>
                </Tooltip>
            )}
            {copyVideoLink && (
                <Tooltip title={copyVideoLink.title} placement="top">
                    <Button
                        aria-label="copy"
                        className={classes.copyButton}
                        size="small"
                        startIcon={<VideocamIcon />}
                        onClick={copyVideoLink.callback}
                    >
                        {TranslationHelper.translate('Copy video link')}
                    </Button>
                </Tooltip>
            )}
            {downloadProps && (
                <>
                    {downloadInProgress ? (
                        <Box
                            sx={{
                                display: 'flex',
                                marginLeft: 8,
                                marginTop: 2,
                                marginBottom: 8,
                            }}
                        >
                            <CircularProgress
                                aria-label="download-circular-progress"
                                size={15}
                            />
                        </Box>
                    ) : (
                        <Tooltip
                            title={TranslationHelper.translate(
                                'Save video as a file'
                            )}
                            placement="top"
                        >
                            <Button
                                aria-label="download"
                                className={classes.copyButton}
                                size="small"
                                startIcon={<DownloadIcon />}
                                onClick={handleDownloadMovie}
                            >
                                {TranslationHelper.translate('Download video')}
                            </Button>
                        </Tooltip>
                    )}
                    <Tooltip
                        title={TranslationHelper.translate(
                            'Save frame as a file at current slider position'
                        )}
                        placement="top"
                    >
                        <Button
                            aria-label="copy"
                            className={classes.copyButton}
                            size="small"
                            startIcon={<CropOriginalIcon />}
                            onClick={handleDownloadFrame}
                        >
                            {TranslationHelper.translate('Download frame')}
                        </Button>
                    </Tooltip>
                </>
            )}
        </div>
    );
};

export default PlayerDropdownOptions;
